import { createSlice } from '@reduxjs/toolkit';
// utils
import axios from '../../utils/axios';
//
import { dispatch } from '../store';

// ----------------------------------------------------------------------

const initialState = {
  isMaterialGroupLoading: false,
  isMaterialCategoryLoading: false,
  isMaterialTypeLoading: false,
  isVenderGroupLoading: false,
  isVenderTypeLoading: false,
  isInventoryMaterialLoading: false,
  isVendorLoading: false,
  isMaterialLoading: false,
  error: null,
  materialgroups: null,
  materialcategories: null,
  materialtypes: null,
  vendorgroups: null,
  vendortypes: null,
  vendors: null,
  inventorymaterials: null,
  materials: null,
};

const slice = createSlice({
  name: 'asset',
  initialState,
  reducers: {
    // START LOADING
    startMaterialGroupLoading(state) {
      state.isMaterialGroupLoading = true;
    },
    startMaterialCategoryLoading(state) {
      state.isMaterialCategoryLoading = true;
    },
    startMaterialTypeLoading(state) {
      state.isMaterialTypeLoading = true;
    },
    startVenderGroupLoading(state) {
      state.isVenderGroupLoading = true;
    },
    startVenderTypeLoading(state) {
      state.isVenderTypeLoading = true;
    },
    startVendorLoading(state) {
      state.isVendorLoading = true;
    },
    startInventoryMaterialLoading(state) {
      state.isInventoryMaterialLoading = true;
    },
    startMaterialLoading(state) {
      state.isMaterialLoading = true;
    },
    // HAS ERROR
    hasError(state, action) {
      state.isMaterialGroupLoading = false;
      state.isMaterialCategoryLoading = false;
      state.isMaterialTypeLoading = false;
      state.isVenderGroupLoading = false;
      state.isVenderTypeLoading = false;
      state.isInventoryMaterialLoading = false;
      state.isMaterialLoading = false;
      state.isVendorLoading = false;
      state.error = action.payload;
    },
    // GET MATERIALGROUPS
    setMaterialGroups(state, action) {
      state.isMaterialGroupLoading = false;
      state.materialgroups = action.payload;
    },
    // GET MATERIALCATEGORY
    setMaterialCategory(state, action) {
      state.isMaterialCategoryLoading = false;
      state.materialcategories = action.payload;
    },
    // GET MATERIALTYPES
    setMaterialTypes(state, action) {
      state.isMaterialTypeLoading = false;
      state.materialtypes = action.payload;
    },
    // GET VENDERGROUPS
    setVenderGroups(state, action) {
      state.isVenderGroupLoading = false;
      state.vendorgroups = action.payload;
    },
    // GET VENDERTYPES
    setVenderTypes(state, action) {
      state.isVenderTypeLoading = false;
      state.vendortypes = action.payload;
    },
    // GET VENDERS
    setVendors(state, action) {
      state.isVendorLoading = false;
      state.vendors = action.payload;
    },
    // GET INVENTORYMATERIALS
    setInventoryMaterials(state, action) {
      state.isInventoryMaterialLoading = false;
      state.inventorymaterials = action.payload;
    },
    // GET MATERIALS
    setMaterials(state, action) {
      state.isMaterialLoading = false;
      state.materials = action.payload;
    },
  },
});

// Reducer
export default slice.reducer;

// Actions
export const {
  hasError,
  startMaterialGroupLoading,
  startMaterialCategoryLoading,
  startMaterialTypeLoading,
  startVenderGroupLoading,
  startVenderTypeLoading,
  startVendorLoading,
  startInventoryMaterialLoading,
  startMaterialLoading,
} = slice.actions;

// ----------------------------------------------------------------------
export function getMaterials() {
  return async () => {
    dispatch(slice.actions.startMaterialLoading());
    try {
      const response = await axios.get(`/dropdown/assets/materials`);
      dispatch(slice.actions.setMaterials(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getMaterialGroups() {
  return async () => {
    dispatch(slice.actions.startMaterialGroupLoading());
    try {
      const response = await axios.get(`/dropdown/assets/material_groups`);
      dispatch(slice.actions.setMaterialGroups(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getMaterialCategory() {
  return async () => {
    dispatch(slice.actions.startMaterialCategoryLoading());
    try {
      const response = await axios.get(`/dropdown/assets/material_categories`);
      dispatch(slice.actions.setMaterialCategory(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
export function getMaterialTypes() {
  return async () => {
    dispatch(slice.actions.startMaterialTypeLoading());
    try {
      const response = await axios.get(`/dropdown/assets/material_types`);
      dispatch(slice.actions.setMaterialTypes(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getVenderGroups() {
  return async () => {
    dispatch(slice.actions.startVenderGroupLoading());
    try {
      const response = await axios.get(`/dropdown/assets/vendor_groups`);
      dispatch(slice.actions.setVenderGroups(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getVendors(companyId) {
  return async () => {
    dispatch(slice.actions.startVendorLoading());
    try {
      const response = await axios.get(`dropdown/assets/vendors`, {
        params: {
          company_id: companyId,
        },
      });
      dispatch(slice.actions.setVendors(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getVenderTypes() {
  return async () => {
    dispatch(slice.actions.startVenderTypeLoading());
    try {
      const response = await axios.get(`/dropdown/assets/vendor_types`);
      dispatch(slice.actions.setVenderTypes(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
export function getInventoryMaterials() {
  return async () => {
    dispatch(slice.actions.startInventoryMaterialLoading());
    try {
      const response = await axios.get(`/admin/assets/inventory_materials`);
      dispatch(slice.actions.setInventoryMaterials(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getAvailableInventoryMaterials() {
  return async () => {
    dispatch(slice.actions.startInventoryMaterialLoading());
    try {
      const response = await axios.get(`/admin/assets/dropdown/available_inventorys`);
      dispatch(slice.actions.setInventoryMaterials(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
